export default function MainSiteCTA() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-3xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20top%20down%20view%20of%20curated%20shopping%20collection%20with%20designer%20sneakers%20leather%20accessories%20and%20folded%20garments%20arranged%20on%20warm%20honey%20colored%20wooden%20surface%20with%20morning%20coffee%20soft%20natural%20light%20retail%20editorial%20photography&width=1200&height=600&seq=main-cta-shopping-v2&orientation=landscape"
            alt="Shop verified products at kaspreadsheet.com"
            title="Superbuy Spreadsheet - Shop Now"
            className="w-full aspect-[2/1] object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-foreground-900/10"></div>
        </div>

        <p className="text-sm font-label tracking-widest uppercase text-foreground-400 mb-4">
          Verified Products
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight mb-2">
          Superbuy Spreadsheet
        </h2>
        <p className="text-lg text-foreground-500 mb-10">
          Shop Now — All Categories Available
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Superbuy Sheet
            <i className="ri-external-link-line text-sm"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}